import { ToggleButton, ToggleButtonGroup } from "@mui/material"

import { type Periodicity, timeframeConfig } from "@/App/Equities/shared/utils"
import { Stack } from "@/generated/material"

import { setPeriodicity, usePeriodicity } from "./state"

export const TimeframeSelector = () => {
  const currentPeriod = usePeriodicity()

  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    periodicity: Periodicity | null,
  ) => {
    if (periodicity) {
      setPeriodicity(periodicity)
    }
  }

  return (
    <Stack alignItems="center">
      <ToggleButtonGroup
        value={currentPeriod}
        exclusive
        onChange={handleChange}
        size="small"
      >
        {Object.values(timeframeConfig).map((config) => (
          <ToggleButton
            key={config.timeframe}
            value={config}
            size="medium"
            data-testid={config.timeframe}
          >
            {config.timeframe}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  )
}
